import script from "./ModalQr.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalQr.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__